export enum AddressIdentificationId {
  ID_CZE = 2,
  VAT_ID_CZE = 4,
  ID_SVK = 6,
  VAT_ID_SVK = 8,
  ID_AUT = 10,
  VAT_ID_AUT = 12,
  ID_POL = 14,
  VAT_ID_POL = 16,
  ID_GBR = 18,
  VAT_ID_GBR = 20,
  ID_USA = 22,
  VAT_ID_USA = 24,
  ID_SVN = 26,
  VAT_ID_SVN = 28,
  ID_HUN = 30,
  VAT_ID_HUN = 32,
  ID_FRA = 34,
  VAT_ID_FRA = 36,
  ID_IDN = 38,
  VAT_ID_IDN = 40,
  ID_UKR = 42,
  VAT_ID_UKR = 44,
  ID_CHE = 46,
  VAT_ID_CHE = 48,
  ID_ESP = 50,
  VAT_ID_ESP = 52,
  ID_MAR = 54,
  VAT_ID_MAR = 56,
  ID_MUS = 58,
  VAT_ID_MUS = 60,
  ID_TUR = 62,
  VAT_ID_TUR = 64,
  ID_IRL = 66,
  VAT_ID_IRL = 68,
  ID_CHN = 86,
  VAT_ID_CHN = 88,
  ID_DEU = 90,
  VAT_ID_DEU = 92,
  ID_BGR = 94,
  VAT_ID_BGR = 96,
  ID_NLD = 98,
  VAT_ID_NLD = 100,
  ID_ITA = 102,
  VAT_ID_ITA = 104,
  ID_BEL = 106,
  VAT_ID_BEL = 108,
  ID_ROU = 110,
  VAT_ID_ROU = 112,
  ID_LVA = 114,
  VAT_ID_LVA = 116,
  ID_HRV = 118,
  VAT_ID_HRV = 120,
  ID_GRC = 122,
  VAT_ID_GRC = 124,
  ID_LTU = 126,
  VAT_ID_LTU = 128,
  ID_AUS = 130,
  VAT_ID_AUS = 132,
  ID_RUS = 134,
  VAT_ID_RUS = 136,
  ID_MEX = 138,
  VAT_ID_MEX = 140,
  ID_PRT = 142,
  VAT_ID_PRT = 144,
  ID_BLR = 146,
  VAT_ID_BLR = 148,
  ID_CAN = 150,
  VAT_ID_CAN = 152,
  ID_EST = 154,
  VAT_ID_EST = 156,
  ID_SRB = 158,
  VAT_ID_SRB = 160,
  ID_DNK = 162,
  VAT_ID_DNK = 164,
  ID_MKD = 166,
  VAT_ID_MKD = 168,
  ID_SGP = 170,
  VAT_ID_SGP = 172,
  ID_MDA = 174,
  VAT_ID_MDA = 176,
  ID_ISR = 178,
  VAT_ID_ISR = 180,
  ID_GNB = 182,
  VAT_ID_GNB = 184,
  ID_ARM = 186,
  VAT_ID_ARM = 188,
  ID_SWE = 190,
  VAT_ID_SWE = 192,
  ID_FIN = 194,
  VAT_ID_FIN = 196,
  ID_TWN = 198,
  VAT_ID_TWN = 200,
  ID_LIE = 202,
  VAT_ID_LIE = 204,
  ID_ISL = 206,
  VAT_ID_ISL = 208,
  ID_SLV = 210,
  VAT_ID_SLV = 212,
  ID_NGA = 214,
  VAT_ID_NGA = 216,
  ID_MYS = 218,
  VAT_ID_MYS = 220,
  ID_IND = 222,
  VAT_ID_IND = 224,
  ID_ZAF = 226,
  VAT_ID_ZAF = 228,
  ID_GHA = 230,
  VAT_ID_GHA = 232,
  ID_KAZ = 234,
  VAT_ID_KAZ = 236,
  ID_COK = 238,
  VAT_ID_COK = 240,
  ID_PAK = 242,
  VAT_ID_PAK = 244,
  VAT_ID_ADD_SVK = 246,
  ID_CRI = 248,
  ID_DOM = 250,
  VAT_ID_DOM = 252,
  STREET_TYPE_HUN = 254,
  IDENT_CZE = 256,
  IDENT_AFG = 258,
  IDENT_ALB = 260,
  IDENT_DZA = 262,
  IDENT_ASM = 264,
  IDENT_VIR = 266,
  IDENT_AND = 268,
  IDENT_AGO = 270,
  IDENT_AIA = 272,
  IDENT_ATA = 274,
  IDENT_ATG = 276,
  IDENT_ARG = 278,
  IDENT_ARM = 280,
  IDENT_ABW = 282,
  IDENT_AUS = 284,
  IDENT_BHS = 286,
  IDENT_BHR = 288,
  IDENT_BGD = 290,
  IDENT_BRB = 292,
  IDENT_BEL = 294,
  IDENT_BLZ = 296,
  IDENT_BLR = 298,
  IDENT_BEN = 300,
  IDENT_BMU = 302,
  IDENT_BTN = 304,
  IDENT_BOL = 306,
  IDENT_BIH = 308,
  IDENT_BWA = 310,
  IDENT_BVT = 312,
  IDENT_BRA = 314,
  IDENT_IOT = 316,
  IDENT_VGB = 318,
  IDENT_BRN = 320,
  IDENT_BGR = 322,
  IDENT_BFA = 324,
  IDENT_BDI = 326,
  IDENT_COK = 328,
  IDENT_CHN = 330,
  IDENT_DNK = 332,
  IDENT_DMA = 334,
  IDENT_DOM = 336,
  IDENT_DJI = 338,
  IDENT_TCD = 340,
  IDENT_EGY = 342,
  IDENT_ECU = 344,
  IDENT_ERI = 346,
  IDENT_EST = 348,
  IDENT_ETH = 350,
  IDENT_FRO = 352,
  IDENT_FLK = 354,
  IDENT_FJI = 356,
  IDENT_PHL = 358,
  IDENT_FIN = 360,
  IDENT_FRA = 362,
  IDENT_GAB = 364,
  IDENT_GMB = 366,
  IDENT_GHA = 368,
  IDENT_GIB = 370,
  IDENT_GRD = 372,
  IDENT_GRL = 374,
  IDENT_GEO = 376,
  IDENT_GUM = 378,
  IDENT_GTM = 380,
  IDENT_GIN = 382,
  IDENT_GNB = 384,
  IDENT_GUY = 386,
  IDENT_HTI = 388,
  IDENT_HMD = 390,
  IDENT_HND = 392,
  IDENT_HKG = 394,
  IDENT_CHL = 396,
  IDENT_HRV = 398,
  IDENT_IND = 400,
  IDENT_IDN = 402,
  IDENT_IRQ = 404,
  IDENT_IRN = 406,
  IDENT_IRL = 408,
  IDENT_ISL = 410,
  IDENT_ITA = 412,
  IDENT_ISR = 414,
  IDENT_JAM = 416,
  IDENT_JPN = 418,
  IDENT_YEM = 420,
  IDENT_ZAF = 422,
  IDENT_SGS = 424,
  IDENT_JOR = 426,
  IDENT_CYM = 430,
  IDENT_KHM = 432,
  IDENT_CMR = 434,
  IDENT_CAN = 436,
  IDENT_CPV = 438,
  IDENT_QAT = 440,
  IDENT_KAZ = 442,
  IDENT_KEN = 444,
  IDENT_KIR = 446,
  IDENT_CCK = 448,
  IDENT_COL = 450,
  IDENT_COM = 452,
  IDENT_COG = 454,
  IDENT_COD = 456,
  IDENT_PRK = 458,
  IDENT_KOR = 460,
  IDENT_CUB = 462,
  IDENT_KWT = 464,
  IDENT_CYP = 466,
  IDENT_KGZ = 468,
  IDENT_LAO = 470,
  IDENT_LSO = 472,
  IDENT_LBN = 474,
  IDENT_LBR = 476,
  IDENT_LBY = 478,
  IDENT_LIE = 480,
  IDENT_LTU = 482,
  IDENT_LVA = 484,
  IDENT_LUX = 486,
  IDENT_MAC = 488,
  IDENT_MDG = 490,
  IDENT_MKD = 492,
  IDENT_MYS = 494,
  IDENT_MWI = 496,
  IDENT_MDV = 498,
  IDENT_MLI = 500,
  IDENT_MLT = 502,
  IDENT_MAR = 504,
  IDENT_MHL = 506,
  IDENT_MUS = 508,
  IDENT_MRT = 510,
  IDENT_UMI = 512,
  IDENT_MEX = 514,
  IDENT_FSM = 516,
  IDENT_MDA = 518,
  IDENT_MCO = 520,
  IDENT_MNG = 522,
  IDENT_MSR = 524,
  IDENT_MOZ = 526,
  IDENT_MMR = 528,
  IDENT_NAM = 530,
  IDENT_NRU = 532,
  IDENT_DEU = 534,
  IDENT_NPL = 536,
  IDENT_NER = 538,
  IDENT_NGA = 540,
  IDENT_NIC = 542,
  IDENT_NIU = 544,
  IDENT_NLD = 548,
  IDENT_NFK = 550,
  IDENT_NOR = 552,
  IDENT_NZL = 554,
  IDENT_OMN = 556,
  IDENT_PAK = 558,
  IDENT_PLW = 560,
  IDENT_PAN = 562,
  IDENT_PNG = 564,
  IDENT_PRY = 566,
  IDENT_PER = 568,
  IDENT_PCN = 570,
  IDENT_CIV = 572,
  IDENT_POL = 574,
  IDENT_PRI = 576,
  IDENT_PRT = 578,
  IDENT_AUT = 580,
  IDENT_GNQ = 582,
  IDENT_RUS = 586,
  IDENT_RWA = 588,
  IDENT_GRC = 590,
  IDENT_SLV = 592,
  IDENT_WSM = 594,
  IDENT_SMR = 596,
  IDENT_SAU = 598,
  IDENT_SEN = 600,
  IDENT_MNP = 602,
  IDENT_SYC = 604,
  IDENT_SLE = 606,
  IDENT_SGP = 608,
  IDENT_SVN = 610,
  IDENT_SOM = 612,
  IDENT_ARE = 614,
  IDENT_LKA = 616,
  IDENT_CAF = 618,
  IDENT_SDN = 620,
  IDENT_SUR = 622,
  IDENT_SJM = 624,
  IDENT_SHN = 626,
  IDENT_LCA = 628,
  IDENT_KNA = 630,
  IDENT_STP = 632,
  IDENT_VCT = 634,
  IDENT_SWZ = 636,
  IDENT_SYR = 638,
  IDENT_SLB = 640,
  IDENT_ESP = 642,
  IDENT_SWE = 644,
  IDENT_CHE = 646,
  IDENT_TJK = 648,
  IDENT_TZA = 650,
  IDENT_THA = 652,
  IDENT_TWN = 654,
  IDENT_TGO = 656,
  IDENT_TKL = 658,
  IDENT_TON = 660,
  IDENT_TTO = 662,
  IDENT_TUN = 664,
  IDENT_TUR = 666,
  IDENT_TKM = 668,
  IDENT_TCA = 670,
  IDENT_TUV = 672,
  IDENT_UGA = 674,
  IDENT_UKR = 676,
  IDENT_URY = 678,
  IDENT_UZB = 680,
  IDENT_CXR = 682,
  IDENT_VUT = 684,
  IDENT_VAT = 686,
  IDENT_VEN = 688,
  IDENT_VNM = 690,
  IDENT_TLS = 692,
  IDENT_ZMB = 694,
  IDENT_ESH = 696,
  IDENT_ZWE = 698,
  IDENT_MNE = 700,
  IDENT_XKX = 702,
  IDENT_SRB = 704,
  IDENT_AZE = 706,
  IDENT_ALA = 708,
  IDENT_BES = 710,
  IDENT_CUW = 712,
  IDENT_GUF = 714,
  IDENT_PYF = 716,
  IDENT_ATF = 718,
  IDENT_GLP = 720,
  IDENT_GGY = 722,
  IDENT_IMN = 724,
  IDENT_JEY = 726,
  IDENT_MTQ = 728,
  IDENT_MYT = 730,
  IDENT_NCL = 732,
  IDENT_PSE = 734,
  IDENT_REU = 736,
  IDENT_BLM = 738,
  IDENT_MAF = 740,
  IDENT_SPM = 742,
  IDENT_SXM = 744,
  IDENT_SSD = 746,
  IDENT_WLF = 748,
  IDENT_GBR = 750,
  IDENT_CRI = 752,
  IDENT_USA = 754,
  IDENT_HUN = 756,
  COUNTY_ROU = 757,
  CNP_ROU = 759,
  SECTOR_ROU = 761,
  BASIC_CAPITAL_ROU = 763,
  ADDITIONAL_ADDRESS_ROU = 765,
  VAT_EU_NUMBER_HUN = 767,
  GROUP_VAT_NUMBER_HUN = 769,
  JST_NAME_PL = 771,
  JST_NIP_PL = 772,
  JST_ROLE_PL = 773,
}
